/* PEONLY Seiten 2 (Kontakt, Über uns, Exklusiv): Blüten-Parallaxe + Pop, Kopieren-Button, Über-uns-Blüte mit 6 Punkten (Tabs, Tastatur, optional Auto-Wechsel),
   Exklusiv-Registrierung (customer[note] aus den Zusatzfeldern bauen), Formular-Status. Ergänzt peonly-startseite.js (dort: Einblenden).
   Funktioniert mehrfach und im Theme-Editor (shopify:section:load). Respektiert prefers-reduced-motion. */
(function(){
  if (window.PeonlySeiten2) return;
  var W = window, D = document;
  var mq = W.matchMedia('(prefers-reduced-motion: reduce)');
  var rm = mq.matches; if (mq.addEventListener) mq.addEventListener('change', function(e){ rm = e.matches; });
  var fine = W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function qa(r, s){ return [].slice.call(r.querySelectorAll(s)); }
  function q(r, s){ return r.querySelector(s); }

  /* ---------- gemeinsam: Formular-Status (Senden-Knopf sperren, Erfolgsmeldung zentrieren) ---------- */
  function forms(root){
    qa(root, 'form').forEach(function(f){
      if (f.__pe2) return; f.__pe2 = 1;
      var btn = q(f, '[type=submit]');
      f.addEventListener('submit', function(){
        if (!btn || (f.checkValidity && !f.checkValidity())) return;
        btn.setAttribute('data-label', btn.innerHTML);
        var t = btn.getAttribute('data-sending'); if (t) btn.textContent = t;
        setTimeout(function(){ btn.disabled = true; }, 0);
      });
    });
    W.addEventListener('pageshow', function(e){
      if (!e.persisted) return;
      qa(root, '[type=submit][data-label]').forEach(function(b){ b.disabled = false; b.innerHTML = b.getAttribute('data-label'); });
      qa(root, '[name^="pe-x-"]').forEach(function(e){ e.disabled = false; });
    });
    var posted = q(root, '[data-posted]');
    if (posted) setTimeout(function(){ try { posted.scrollIntoView({ block: 'center', behavior: rm ? 'auto' : 'smooth' }); } catch (e) {} }, 80);
  }

  /* ---------- schwebende Blüten: Parallaxe + Pop ---------- */
  function deco(root){
    var fl = q(root, '[data-pe-fl]'); if (!fl || rm) return;
    if (fine) {
      var host = fl.parentNode, raf = 0, nx = 0, ny = 0;
      host.addEventListener('pointermove', function(e){
        var b = host.getBoundingClientRect(); nx = ((e.clientX - b.left) / b.width - .5) * 2; ny = ((e.clientY - b.top) / b.height - .5) * 2;
        if (!raf) raf = requestAnimationFrame(function(){ raf = 0; fl.style.setProperty('--px', nx.toFixed(3)); fl.style.setProperty('--py', ny.toFixed(3)); });
      });
      host.addEventListener('pointerleave', function(){ fl.style.setProperty('--px', 0); fl.style.setProperty('--py', 0); });
    }
    fl.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('[data-pe-pop]') : null; if (!b || b.classList.contains('pe-pop')) return;
      var r = b.getBoundingClientRect(), h = fl.getBoundingClientRect(), cx = r.left - h.left + r.width / 2, cy = r.top - h.top + r.height / 2;
      b.classList.add('pe-pop');
      var cols = ['#F4B6C6', '#E98BA6', '#F8D3DD', '#D9708F', '#FBE4EA', '#C96C8C'];
      for (var i = 0; i < 7; i++) {
        var p = D.createElement('i'), a = i / 7 * 6.283 + Math.random() * .6, d = 60 + Math.random() * 90, w = 16 + Math.random() * 14;
        p.className = 'pe-fl-p pe-burst';
        p.style.cssText = '--bx:' + cx.toFixed(0) + 'px;--by:' + cy.toFixed(0) + 'px;--w:' + w.toFixed(0) + 'px;--c:' + cols[i % cols.length] + ';--dx:' + (Math.cos(a) * d).toFixed(0) + 'px;--dy:' + (Math.sin(a) * d + 40).toFixed(0) + 'px;--dr:' + ((Math.random() - .5) * 400).toFixed(0) + 'deg';
        p.addEventListener('animationend', function(){ if (this.parentNode) this.parentNode.removeChild(this); });
        fl.appendChild(p);
      }
      setTimeout(function(){ b.classList.remove('pe-pop'); }, 2200);
    });
  }

  /* ---------- Kontakt: E-Mail kopieren ---------- */
  function copyBtn(root){
    qa(root, '[data-pe-copy]').forEach(function(b){
      b.addEventListener('click', function(){
        var t = b.getAttribute('data-pe-copy'), ok = b.getAttribute('data-ok') || 'Kopiert ✓', old = b.textContent;
        function done(){ b.textContent = ok; setTimeout(function(){ b.textContent = old; }, 1800); }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(done, function(){});
        else { var x = D.createElement('textarea'); x.value = t; x.style.cssText = 'position:fixed;opacity:0'; D.body.appendChild(x); x.select(); try { D.execCommand('copy'); done(); } catch (e) {} D.body.removeChild(x); }
      });
    });
  }

  /* ---------- Über uns: Blüte mit Punkten ---------- */
  function ueberUns(root){
    var wrap = root.matches && root.matches('.pe-uu') ? root : q(root, '.pe-uu'); if (!wrap || wrap.__uu) return; wrap.__uu = 1;
    var stage = q(wrap, '.pe-uu-stage'), btns = qa(wrap, '.pe-uu-pt button'), imgs = qa(wrap, '.pe-uu-bloom img'), panels = qa(wrap, '.pe-uu-panel');
    if (!btns.length) return;
    var cur = -1, timer = 0, userTouched = false;
    wrap.classList.add('pe-uu--js');
    function set(i, focus){
      i = (i + btns.length) % btns.length; if (i === cur) { if (focus) btns[i].focus(); return; }
      cur = i;
      btns.forEach(function(b, j){ var on = j === i; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      imgs.forEach(function(m, j){ m.classList.toggle('pe-on', j === i); });
      panels.forEach(function(p, j){ p.classList.toggle('pe-on', j === i); });
      var tint = btns[i].parentNode.style.getPropertyValue('--tint'); if (tint && stage) stage.style.setProperty('--pe-tint', tint);
      if (focus) btns[i].focus();
    }
    btns.forEach(function(b, i){
      b.addEventListener('click', function(){ userTouched = true; stop(); set(i); });
      b.addEventListener('keydown', function(e){
        var k = e.key, n = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = i + 1; else if (k === 'ArrowLeft' || k === 'ArrowUp') n = i - 1;
        else if (k === 'Home') n = 0; else if (k === 'End') n = btns.length - 1; else return;
        e.preventDefault(); userTouched = true; stop(); set(n, true);
      });
      if (fine) { var ht = 0;
        b.addEventListener('pointerenter', function(e){ if (e.pointerType && e.pointerType !== 'mouse') return; clearTimeout(ht); ht = setTimeout(function(){ userTouched = true; stop(); set(i); }, 90); });
        b.addEventListener('pointerleave', function(){ clearTimeout(ht); });
      }
    });
    function stop(){ if (timer) { clearInterval(timer); timer = 0; } }
    function start(){
      var auto = wrap.getAttribute('data-auto') === 'true', ms = (parseInt(wrap.getAttribute('data-interval'), 10) || 7) * 1000;
      if (!auto || rm || userTouched || timer || D.documentElement.classList.contains('pe-dm')) return;
      timer = setInterval(function(){ if (!D.hidden) set(cur + 1); }, ms);
    }
    wrap.addEventListener('pointerenter', stop); wrap.addEventListener('focusin', stop);
    wrap.addEventListener('pointerleave', start);
    wrap.addEventListener('shopify:block:select', function(e){ var i = btns.findIndex ? btns.findIndex(function(b){ return b.getAttribute('data-block') === e.target.getAttribute('data-block'); }) : -1; if (i >= 0) set(i); });
    var first = 0; btns.forEach(function(b, i){ if (b.getAttribute('aria-selected') === 'true') first = i; });
    set(first); start();
  }

  /* ---------- Exklusiv: Registrierung ---------- */
  function val(f, n){ var e = f.elements[n]; return e && e.value ? String(e.value).trim() : ''; }
  function buildNote(f){
    var typ = (f.querySelector('input[name="pe-x-typ"]:checked') || {}).value || '';
    var l = ['Exklusiv-Anfrage (Registrierung über die Seite „Exklusiv“)'];
    l.push('Kundentyp: ' + (typ || '–'));
    if (typ === 'gewerblich' && val(f, 'pe-x-firma')) l.push('Firma: ' + val(f, 'pe-x-firma'));
    l.push('Telefon: ' + (val(f, 'pe-x-tel') || '–'));
    l.push('Straße/Hausnummer: ' + val(f, 'pe-x-str'));
    l.push('PLZ/Ort: ' + val(f, 'pe-x-plz') + ' ' + val(f, 'pe-x-ort'));
    l.push('Land: ' + val(f, 'pe-x-land'));
    l.push('USt-IdNr: ' + (val(f, 'pe-x-ust') || '– (nicht angegeben)'));
    l.push('Einwilligung Datenschutz/AGB: ' + (f.elements['pe-x-dsgvo'] && f.elements['pe-x-dsgvo'].checked ? 'ja' : 'nein'));
    return l.join('\n');
  }
  function exklusiv(root){
    qa(root, 'form[data-pe-x-reg]').forEach(function(f){
      if (f.__x) return; f.__x = 1;
      var note = f.elements['customer[note]'], co = q(f, '.pe-x-co'), btn = q(f, '[type=submit]');
      if (btn) btn.disabled = false;                       /* ohne JS bleibt der Knopf gesperrt (siehe Markup), damit nie eine Anfrage ohne Zusatzdaten ankommt */
      function typ(){ var t = (f.querySelector('input[name="pe-x-typ"]:checked') || {}).value; if (co) co.hidden = t !== 'gewerblich'; }
      qa(f, 'input[name="pe-x-typ"]').forEach(function(r){ r.addEventListener('change', typ); }); typ();
      f.addEventListener('submit', function(){
        if (note) note.value = buildNote(f);
        qa(f, '[name^="pe-x-"]').forEach(function(e){ e.disabled = true; });   /* Zusatzfelder nicht mitsenden (stehen im Notizfeld) */
      }, true);
    });
  }

  function setup(root){
    forms(root); deco(root); copyBtn(root); ueberUns(root); exklusiv(root);
    qa(root, '[data-pe-seite2-ready]').forEach(function(e){ e.setAttribute('data-pe-seite2-ready', 'true'); });
  }
  function boot(){ qa(D, '[data-pe-seite2]').forEach(setup); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', function(e){ qa(e.target, '[data-pe-seite2]').forEach(setup); });
  W.PeonlySeiten2 = { buildNote: buildNote, set: function(){ } };
})();
